function getWrapper() {
    const wrapper = document.querySelector('#documentation');
    if (wrapper == null) {
        throw new Error('Supporting documents wrapper not found');
    }
    return wrapper;
}

function setVisibility(isVisible = true) {
    const wrapper = getWrapper();
    wrapper.classList.toggle('d-none', !isVisible);
}

function setDescription(description) {
    const wrapper = getWrapper();
    const descriptionElement = wrapper.querySelectorAll('p')[0];
    descriptionElement.textContent = description;
}

function setRequired(isRequired = true) {
    const wrapper = getWrapper();
    const fileUploadElement = wrapper.querySelector('#file-upload');
    const fileDescriptionElement = wrapper.querySelector('#file-description');

    fileUploadElement.required = isRequired;
    fileUploadElement.classList.toggle('is-invalid', isRequired);
    fileDescriptionElement.required = isRequired;
    fileDescriptionElement.classList.toggle('is-invalid', isRequired);
    if (isRequired) {
        fileDescriptionElement.setCustomValidity('You must click the "Add File" button to upload your proof of purchase.');
    } else {
        fileDescriptionElement.setCustomValidity('');
    }
}

function hasUploadedFiles() {
    const wrapper = getWrapper();
    return wrapper.querySelector('#file-list').children.length > 0;
}

export default {
    setVisibility,
    setDescription,
    setRequired,
    hasUploadedFiles
}